import DOMPurify from 'dompurify';
const chartCfg = window.BarChartConfig ?? {};
const { project_year } = chartCfg;
/**
 * Optimized barchart.js for jQuery 3 and ES5, handling radio sets and pie charts
 */
(function ($) {
  function debounce(func, wait) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  var tableMap = {
    all: { show: '#table004', hide: ['#table001', '#table002', '#table003', '#table005'] },
    distributed14: { show: '#table001', hide: ['#table002', '#table003', '#table004', '#table005'] },
    distributed5: { show: '#table005', hide: ['#table001', '#table002', '#table003', '#table004'] },
    facilities: { show: '#table002', hide: ['#table001', '#table003', '#table004', '#table005'] },
    community: { show: '#table003', hide: ['#table001', '#table002', '#table004', '#table005'] }
  };

  function setupBarChartRadios($container) {
    $container.find('.radio-set .project-select input').on('change', debounce(function () {
      var className = $(this).attr('value') || '';
      if (tableMap.hasOwnProperty(className)) {
        var map = tableMap[className];
        for (var i = 0; i < map.hide.length; i++) {
          $container.find(map.hide[i]).addClass('hidden');
        }
        $container.find(map.show).removeClass('hidden');
      }
    }, 100));
  }

  function pieChartHandler(attrKey, sectionIndex) {
    return debounce(function () {
      var $container = $(this).closest('div[id^="pie-chart-yr"]');
      var $filterSection = $container.find('#data-tables .wpdt-c .wpDataTableFilterBox .wpDataTableFilterSection:nth-child(' + sectionIndex + ') .checkbox');
      var attr = $(this).hasClass('all') ? 'all' : $(this).attr(attrKey);
      if (attr === 'all') {
        $filterSection.find('.wdt-checkbox-filter:not(:checked)').trigger('click');
      } else {
        var $filters = $filterSection.find('.wdt-checkbox-filter[value*="' + attr + '"]');
        if ($filters.length) {
          $filters.filter(':not(:checked)').trigger('click');
          $filterSection.find(':not(.wdt-checkbox-filter[value*="' + attr + '"]):checked').trigger('click');
          $container.find('.pie-chart-group #project-item > .highcharts_pie_chart').removeClass('hidden');
        } else {
          $container.find('.pie-chart-group #project-item > .highcharts_pie_chart').addClass('hidden');
        }
      }
    }, 100);
  }

  function chartsReady() {
    return (typeof window.wpDataCharts !== 'undefined' && typeof window.Highcharts !== 'undefined');
  }
  function whenChartsReady(fn, timeoutMs = 10000, intervalMs = 200) {
    const start = Date.now();
    (function tick() {
      if (chartsReady()) return fn();
      if (Date.now() - start > timeoutMs) return;
      setTimeout(tick, intervalMs);
    })();
  }

  whenChartsReady(() => {
    if ($('body').hasClass('project-dashboard')) {
      $(function () {
        var $pss = $('div[id^="pss-"]');
        $pss.each(function () {
          var ids = ['#table001', '#table002', '#table003', '#table005'], i;
          for (i = 0; i < ids.length; i++) {
            $(this).find(ids[i]).addClass('hidden');
          }
        });

        // NOTE: broadened selector to support year 10+ (no single-digit assumption)
        var $stageTables = $('[id^="bar-chart-yr"]');
        $stageTables.each(function () {
          setupBarChartRadios($(this));
        });

        $('div[id^="pie-chart-yr"] .radio-set .project-select label').on('click', pieChartHandler('data-project', 1));
        $('div[id^="pie-chart-yr"] .radio-set .stage-select label').on('click', pieChartHandler('data-stage', 2));
      });
    }

    function round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    }

    if ($('body').hasClass('project-dashboard')) {
      window.wpDataChartsCallbacks = window.wpDataChartsCallbacks || {};
      var project_years_check_limit = 30;
      var filter = [];
      var i;
      for (i = 1; i <= project_years_check_limit; i++) {
        filter.push('Year ' + i);
      }

      var chartConfigs = [
        { mod: 1, colors: ['#5062e5', '#f44e22'], labels: { 'Non-EJ': '#5062e5', 'EJ': '#f44e22' }, formatter: function (y) { return y; } },
        { mod: 2, colors: ['#5062e5', '#f44e22'], labels: { 'No': '#5062e5', 'Yes': '#f44e22' }, formatter: function (y) { return round(y, 0).toLocaleString() + ' kW'; } },
        { mod: 3, colors: ['#5062e5', '#f44e22'], labels: { 'No': '#5062e5', 'Yes': '#f44e22' }, formatter: function (y) { return '$' + round(y / 1000000, 2) + ' MM'; } },
        { mod: 4, colors: ['#5062e5', '#f44e22'], labels: { 'Non-Low Income': '#5062e5', 'Low-Income': '#f44e22' }, formatter: function (y) { return y; } },
        { mod: 5, colors: ['#5062e5', '#f44e22'], labels: { 'No': '#5062e5', 'Yes': '#f44e22' }, formatter: function (y) { return round(y, 0).toLocaleString() + ' kW'; } },
        { mod: 6, colors: ['#5062e5', '#f44e22'], labels: { 'No': '#5062e5', 'Yes': '#f44e22' }, formatter: function (y) { return '$' + round(y / 1000000, 2) + ' MM'; } },
        { mod: 7, colors: ['#5062e5', '#f44e22', '#face0c'], labels: { 'Non-WMBE': '#5062e5', 'WMBE': '#f44e22', 'Certification Pending': '#face0c' }, formatter: function (y) { return y; } },
        { mod: 8, colors: ['#5062e5', '#f44e22', '#face0c'], labels: { 'No': '#5062e5', 'Yes': '#f44e22', 'Certification Pending': '#face0c' }, formatter: function (y) { return round(y, 0).toLocaleString() + ' kW'; } },
        { mod: 9, colors: ['#5062e5', '#f44e22', '#face0c'], labels: { 'No': '#5062e5', 'Yes': '#f44e22', 'Certification Pending': '#face0c' }, formatter: function (y) { return '$' + round(y / 1000000, 2) + ' MM'; } },
        { mod: 10, colors: ['#5062e5', '#f44e22', '#00a0d2', '#face0c', '#1c245e', '#57d984', '#d4d9fa'], labels: { 'ComEd': '#5062e5', 'Ameren': '#f44e22', 'MidAmerican': '#00a0d2', 'Municipal Utility in MISO': '#face0c', 'Rural electric coop in MISO': '#1c245e', 'Municipal Utility in PJM': '#57d984', 'Rural electric coop in PJM': '#d4d9fa' }, formatter: function (y) { return y; } },
        { mod: 11, colors: ['#5062e5', '#f44e22', '#00a0d2', '#face0c', '#1c245e', '#57d984', '#d4d9fa'], labels: { 'ComEd': '#5062e5', 'Ameren': '#f44e22', 'MidAmerican': '#00a0d2', 'Municipal Utility in MISO': '#face0c', 'Rural electric coop in MISO': '#1c245e', 'Municipal Utility in PJM': '#57d984', 'Rural electric coop in PJM': '#d4d9fa' }, formatter: function (y) { return round(y, 0).toLocaleString() + ' kW'; } },
        { mod: 12, colors: ['#5062e5', '#f44e22', '#00a0d2', '#face0c', '#1c245e', '#57d984', '#d4d9fa'], labels: { 'ComEd': '#5062e5', 'Ameren': '#f44e22', 'MidAmerican': '#00a0d2', 'Municipal Utility in MISO': '#face0c', 'Rural electric coop in MISO': '#1c245e', 'Municipal Utility in PJM': '#57d984', 'Rural electric coop in PJM': '#d4d9fa' }, formatter: function (y) { return '$' + round(y / 1000000, 2) + ' MM'; } },
        { mod: 13, colors: ['#5062e5', '#f44e22', '#face0c'], labels: { '': '#5062e5', '1': '#f44e22' }, formatter: function (y) { return y; } },
        { mod: 14, colors: ['#5062e5', '#f44e22', '#face0c'], labels: { '': '#5062e5', '1': '#f44e22' }, formatter: function (y) { return round(y, 0).toLocaleString() + ' kW'; } },
        { mod: 15, colors: ['#5062e5', '#f44e22', '#face0c'], labels: { '': '#5062e5', '1': '#f44e22' }, formatter: function (y) { return '$' + round(y / 1000000, 2) + ' MM'; } },
        { mod: 16, colors: ['#5062e5', '#f44e22', '#00a0d2'], labels: { 'Waukegan': '#5062e5', 'Carbondale-Marion': '#f44e22', 'West Garfield Park': '#00a0d2' }, formatter: function (y) { return y; } },
        { mod: 17, colors: ['#5062e5', '#f44e22', '#00a0d2'], labels: { 'Waukegan': '#5062e5', 'Carbondale-Marion': '#f44e22', 'West Garfield Park': '#00a0d2' }, formatter: function (y) { return round(y, 0).toLocaleString() + ' kW'; } },
        { mod: 18, colors: ['#5062e5', '#f44e22', '#00a0d2'], labels: { 'Waukegan': '#5062e5', 'Carbondale-Marion': '#f44e22', 'West Garfield Park': '#00a0d2' }, formatter: function (y) { return '$' + round(y / 1000000, 2) + ' MM'; } },
        { mod: 19, colors: ['#5062e5', '#f44e22', '#00a0d2'], labels: { '': '#5062e5', '1': '#f44e22' }, formatter: function (y) { return y; } },
        { mod: 20, colors: ['#5062e5', '#f44e22', '#00a0d2'], labels: { '': '#5062e5', '1': '#f44e22' }, formatter: function (y) { return round(y, 0).toLocaleString() + ' kW'; } },
        { mod: 21, colors: ['#5062e5', '#f44e22', '#00a0d2'], labels: { '': '#5062e5', '1': '#f44e22' }, formatter: function (y) { return '$' + round(y / 1000000, 2) + ' MM'; } }
      ];

      var processWpDataCharts = function (attempts, maxAttempts) {
        attempts = attempts || 0;
        maxAttempts = maxAttempts || 20;
        var ready = (typeof window.wpDataCharts !== 'undefined' && typeof window.Highcharts !== 'undefined');
        if (!ready) {
          if (attempts >= maxAttempts) { return; }
          setTimeout(function () { processWpDataCharts(attempts + 1, maxAttempts); }, 500);
          return;
        }
        $.each(window.wpDataCharts, function (index, value) {
          var year = (value.title.match(/Year \d+/g) || [''])[0];
          var yearNumber = year ? parseInt(year.replace('Year ', '')) : 0;
          var mod;
          if (filter.indexOf(year) !== -1) {
            if (yearNumber <= 4) {
              mod = ((index - 1) % 12) + 1;
            } else if (yearNumber === 5) {
              mod = ((index - 49) % 15) + 1;
            } else {
              var offset = 64 + (yearNumber - 6) * 21;
              mod = ((index - offset) % 21) + 1;
            }
          } else {
            mod = 1;
          }
          var config, j;
          for (j = 0; j < chartConfigs.length; j++) {
            if (chartConfigs[j].mod === mod) { config = chartConfigs[j]; break; }
          }
          if (config) {
            window.wpDataChartsCallbacks[index] = function (obj) {
              obj.options.plotOptions = {
                series: { dataLabels: { enabled: false } },
                pie: {
                  colors: config.colors,
                  showInLegend: false,
                  dataLabels: {
                    enabled: true,
                    formatter: function () { return config.formatter(this.y); },
                    color: '#1c245e',
                    distance: config.mod >= 7 ? 2 : 0,
                    softConnector: false
                  }
                }
              };
              var data = obj.options.series[0] && obj.options.series[0].data;
              if (!data) { return; }
              var newData = $.map(data, function (v) {
                var name = v.name == null ? '' : String(v.name);
                var color = config.labels[name] || '#f1f1f1';
                var dataPoint = $.extend({}, v);
                delete dataPoint.color;
                return $.extend(dataPoint, { color: color });
              });
              obj.options.series[0].data = newData;
            };
          }
        });
      };
      processWpDataCharts();
    }

    setTimeout(function () {
      $('#page-loader').removeClass('loaded').addClass('loading');
      $('.project-section').removeClass('loading').addClass('loaded');
    }, 3000);
  });

  // ------------------- Admin: Importer & Snapshot Revert -------------------
  if ($('body').hasClass('tools_page_salesforce-program-import')) {
    $('#salesforce-program-import-form').on('submit', function (e) {
      e.preventDefault();
      window.scrollTo(0, 0);
      var $submitBtn = $('#salesforce-program-import-submit');
      $submitBtn.prop('disabled', true).val('Please wait...');
      const $log = $('.log-output');
      // DO NOT CHANGE THIS LINE (per your request)
      $log.html('<p style="display:flex;"><img src="/wp-admin/images/spinner-2x.gif" style="display:inline-block; width:16px; height:16px; margin-right:8px;"> Importing…</p>');
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: $(this).serialize(),
        success: function (data) {
          let html_log = '';
          if (Array.isArray(data.notice) && data.notice.length) {
            html_log += '<h3>Notices:</h3><ul><li>' +
              data.notice.map(n => DOMPurify.sanitize(String(n))).join('</li><li>') +
              '</li></ul>';
          }
          if (Array.isArray(data.error) && data.error.length) {
            html_log += '<h3>Errors:</h3><ul><li>' +
              data.error.map(e => DOMPurify.sanitize(String(e))).join('</li><li>') +
              '</li></ul>';
          }
          html_log += `<p><b>Import took ${DOMPurify.sanitize(String(data?.stats?.exec_time ?? ''))} seconds.</b></p>`;
          $log.html(html_log);
          $('#salesforce-program-import-submit').prop('disabled', false).val('Run Importer');
        }
      });
    });

    // Snapshot Revert UI
    if (!$('#sf-snapshot-reverter').length) {
      const $panel = $(
        '<div id="sf-snapshot-reverter" class="postbox" style="margin-top:16px;padding:1rem;">' +
          '<h2 class="hndle"><span>Revert CSVs to a Previous Snapshot</span></h2>' +
          '<div class="inside">' +
            '<p><em>Select a Project Year and a timestamp to restore the data tables (CSVs) for that year.</em></p>' +
            '<div style="display:flex; gap:12px; align-items:center; flex-wrap:wrap;">' +
              '<label>Year ' +
                '<select id="sf-snap-year" style="min-width:100px;"></select>' +
              '</label>' +
              '<label>Timestamp ' +
                '<select id="sf-snap-stamp" style="min-width:200px;"><option value="">Select a year first</option></select>' +
              '</label>' +
              '<button id="sf-snap-apply" class="button button-primary" disabled>Apply Snapshot</button>' +
            '</div>' +
            '<div id="sf-snap-messages" style="margin-top:10px;"></div>' +
          '</div>' +
        '</div>'
      );
      $('#salesforce-program-import-form').after($panel);
    }

    const $year = $('#sf-snap-year');
    const $stamp = $('#sf-snap-stamp');
    const $apply = $('#sf-snap-apply');
    const $log = $('.log-output');
    const adminNonce = ($('#sf_nonce').val() || $('#_wpnonce').val() || '').toString();

    function sanitize(s) { return DOMPurify.sanitize(String(s)); }

    function loadSnapshots() {
      $year.prop('disabled', true).html('<option>Loading…</option>');
      $stamp.prop('disabled', true).html('<option value="">Select a year first</option>');
      $apply.prop('disabled', true);

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: { action: 'sf_list_snapshots', _ajax_nonce: adminNonce },
        success: function(resp) {
          $year.empty();
          if (!resp || !resp.success || !resp.data || !Array.isArray(resp.data.years) || !resp.data.years.length) {
            $year.html('<option value="">No snapshots found</option>');
            return;
          }
          $year.append('<option value="">Select…</option>');
          resp.data.years.forEach(function(item) {
            const y = parseInt(item.year, 10);
            const label = 'Year ' + (y < 10 ? ('0' + y) : y);
            $year.append('<option value="' + sanitize(y) + '">' + sanitize(label) + '</option>');
          });
          $year.prop('disabled', false);
        },
        error: function() {
          $year.html('<option value="">Error loading snapshots</option>');
        }
      });
    }

    function populateStampsForYear(y) {
      $stamp.prop('disabled', true).html('<option value="">Loading…</option>');
      $apply.prop('disabled', true);
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: { action: 'sf_list_snapshots', _ajax_nonce: adminNonce },
        success: function(resp) {
          $stamp.empty();
          if (!resp || !resp.success || !resp.data || !Array.isArray(resp.data.years)) {
            $stamp.html('<option value="">No timestamps</option>');
            return;
          }
          const found = resp.data.years.find(function(item) { return parseInt(item.year,10) === parseInt(y,10); });
          if (!found || !Array.isArray(found.stamps) || !found.stamps.length) {
            $stamp.html('<option value="">No timestamps for Year ' + sanitize(y) + '</option>');
            return;
          }
          $stamp.append('<option value="">Select…</option>');
          found.stamps.forEach(function(s) {
            $stamp.append('<option value="' + sanitize(s) + '">' + sanitize(s) + '</option>');
          });
          $stamp.prop('disabled', false);
        },
        error: function() {
          $stamp.html('<option value="">Error</option>');
        }
      });
    }

    $year.on('change', function() {
      const y = parseInt($(this).val(), 10);
      if (!y) {
        $stamp.html('<option value="">Select a year first</option>').prop('disabled', true);
        $apply.prop('disabled', true);
        return;
      }
      populateStampsForYear(y);
    });

    $stamp.on('change', function() {
      const ok = $year.val() && $stamp.val();
      $apply.prop('disabled', !ok);
    });

    $apply.on('click', function(e) {
      e.preventDefault();
      if (!$year.val() || !$stamp.val()) return;
      $apply.prop('disabled', true).text('Applying…');
      $log.html('<p style="display:flex;"><img src="/wp-admin/images/spinner-2x.gif" style="display:inline-block; width:16px; height:16px; margin-right:8px;"> Reverting snapshot…</p>');
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: { action: 'sf_apply_snapshot', y: $year.val(), stamp: $stamp.val(), _ajax_nonce: adminNonce },
        success: function(resp) {
          let html_log = '';
          if (resp && resp.success && resp.data) {
            const data = resp.data;
            if (Array.isArray(data.notice) && data.notice.length) {
              html_log += '<h3>Notices:</h3><ul><li>' +
                data.notice.map(n => sanitize(n)).join('</li><li>') +
                '</li></ul>';
            }
            if (Array.isArray(data.error) && data.error.length) {
              html_log += '<h3>Errors:</h3><ul><li>' +
                data.error.map(e => sanitize(e)).join('</li><li>') +
                '</li></ul>';
            }
          } else {
            html_log = '<p><b>Snapshot apply failed.</b></p>';
          }
          $log.html(html_log);
          $apply.prop('disabled', false).text('Apply Snapshot');
        },
        error: function() {
          $log.html('<p><b>Snapshot apply failed (network).</b></p>');
          $apply.prop('disabled', false).text('Apply Snapshot');
        }
      });
    });

    $(function(){ loadSnapshots(); });
  }
})(jQuery);